<div class="manga-card">
    <img [src]="episode.image" alt="Cover" class="manga-image">
    <div class="manga-info">
        <!-- <span class="tag">Fantasía</span> -->
        <h4 class="manga-title">{{ episode.title }}</h4>
        <p class="manga-description">
            {{ episode.description }}
        </p>
    </div>
    <div class="manga-meta">
        <!-- <span class="lang-tag">ES</span> -->
        <div class="metadata">📅 2025-02-18</div>
        <div class="metadata">👁️ {{ 4000 | shortenNumber }}</div>
    </div>
</div>  